import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "black",
          color: "white",
        },
        arrow: {
          color: "black"
        }
      },
    },
  },
  palette: {
    primary: { main: "#050505", secondary: "#0F0F0F" }, // black
    secondary: { main: "#A78D78" }, // Beige
    tertiary: { main: "#D1593D" }, //Orange
    customColor: {
      green: "#136538",
      secondaryFirst: "#F0F0F0", // Light grey
      secondarySecond: "#656565", // Subtext
      secondaryThird: "#CBCBCB", // Dark grey
      secondaryFourth: "#757575", // Darkest grey
      secondaryFifth: "#535B69", // Paragraph
      lightBeige: "#F6F4F1",
      grey: "#959595",
      white: "#FFFFFF",
      red: "#B60218",
      backdrop: "#00000040",
      lightbrown:"#a58b75",
      lightgrey:"ccc",
      lightbeige: "#F6F4F1",
      avatarBg: "#A78D7826", 
      tripCardHeaderBg: "#A78D781A", 
      borderColor: "#D9D9D9",
      lightBrown:"#7D634F",
      lightBlueBg:"#F0F0F0",
      lightGrey:"#656565",
      lightGreen:"#136538",
      lightPurple:"#A78D7819",
      greenBg:"#1365381A"
    },
  },
  typography: {
    fontFamily: ["Lexend", "EB Garamond", "serif"].join(","),
  },
  customStyles: {
    backdrop: {
      background: "rgba(255, 255, 255, 0.01)",
      backdropFilter: "blur(22px)",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      xsl: 335,
      xsm: 420,
      xsm2: 500,
      sm: 600,
      md: 900,
      lg: 1200,
      lgl: 1300,
      xl: 1536,
      xxl: 1920,
    },
  },
});
